import { Marker, InfoWindow } from '@react-google-maps/api';

// Components
import Icon from './Icon';
// Utils
import { convertEntities } from '../utils/helpers';

const InfoWindowContent = ( { address, content } ) => {
	const { address: currentAddress } = address;
	const { email, phone, website, title, link } = content;

	return (
		<div className="infowindow__content">
			<a href={ link } className="infowindow__link"><h3 className="infowindow__title">{ convertEntities( title ) }</h3></a>
			<ul className="infowindow__data">
				{ currentAddress && ( <li className="infowindow__data-item"><Icon name="map-pin" />{ currentAddress }</li> ) }
				{ phone && ( <li className="infowindow__data-item"><Icon name="phone" />{ phone }</li> ) }
				{ email && ( <li className="infowindow__data-item"><Icon name="email" /><a href={ `mailto:${ email }` }>{ email }</a></li> ) }
				{ website && ( <li className="infowindow__data-item"><Icon name="globe" /><a href={ website } target="_blank" rel="noopener noreferrer">{ website }</a></li> ) }
			</ul>
		</div>
	);
};

const Pin = ( { index, data, clusterer, setSelectedMarker, selectedMarker } ) => {
	const { lat, lng } = data;
	const position = { lat, lng };

	const onClick = () => {
		setSelectedMarker( data );
	};

	const renderInfoWindow = () => {
		if ( ! selectedMarker ) {
			return null;
		}

		if ( selectedMarker.id !== data.id ) {
			return null;
		}

		const { lat: currentLat, lng: currentLng, address, content } = selectedMarker;
		const markerPosition = { lat: currentLat, lng: currentLng };

		return (
			<InfoWindow position={ markerPosition } onCloseClick={ () => {
				setSelectedMarker( null );
			} }>
				<InfoWindowContent address={ address } content={ content } />
			</InfoWindow>
		);
	};

	return (
		<Marker
			key={ index }
			clusterer={ clusterer }
			onClick={ onClick }
			position={ position }
			data={ data }
		>
			{ renderInfoWindow() }
		</Marker>
	);
};

Pin.defaultProps = {
	children: null,
	opacity: 1,
	onClickFunc: () => { },
};

export default Pin;
